import { render, staticRenderFns } from "./CreditNotes.vue?vue&type=template&id=534e899e&scoped=true&"
import script from "./CreditNotes.vue?vue&type=script&lang=js&"
export * from "./CreditNotes.vue?vue&type=script&lang=js&"
import style0 from "./CreditNotes.vue?vue&type=style&index=0&id=534e899e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534e899e",
  null
  
)

export default component.exports